module.exports = __webpack_public_path__ + "static/media/21ECLAC15.4e89ba2b.jpg";